export default __webpack_public_path__ + "static/media/i5.ff861395.png";